import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { ActivityList } from 'containers';
import { FieldWrapper, ErrorBoundary } from 'common/components';
import { Query } from 'react-apollo';
import { FETCH_ALL_ACTIVITIES_WITH_FIELDS } from 'api/activity';

const Activity = ({ season }) => (
  <ErrorBoundary>
    <Query
      query={FETCH_ALL_ACTIVITIES_WITH_FIELDS}
      fetchPolicy="cache-and-network"
      variables={{ season, active: true }}
    >
      {({ loading, error, data }) => {
        if (loading || error) return null; // handle side effects here in the future.
        const {
          getAllActivitiesForField,
          getAllActivitiesForStorage,
          getAllActivitiesForDelivery,
        } = data;
        return (
          <FieldWrapper showFields ignoreMapUpdate>
            <ActivityList
              activities={[
                ...getAllActivitiesForField,
                ...getAllActivitiesForStorage,
                ...getAllActivitiesForDelivery,
              ]}
              showActivityTypes
            />
          </FieldWrapper>
        );
      }}
    </Query>
  </ErrorBoundary>
);

Activity.propTypes = {
  season: PropTypes.number.isRequired,
};

const mapState = ({ settings }) => ({ season: settings.season });

export default connect(mapState)(Activity);



// WEBPACK FOOTER //
// ./src/pages/Activity/index.js